import FpImage from './FpImage.jsx'
export default FpImage
